import { render, staticRenderFns } from "./nominationLayout.vue?vue&type=template&id=1938fa16"
import script from "./nominationLayout.vue?vue&type=script&lang=js"
export * from "./nominationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports